import React, { useState, useEffect } from 'react';
import api from '@/services/ApiService';

export const ApiAggregation = ({
  id = null,
  resource = 'party',
  filter = null,
  mapResponse,
  placeholder = '...',
}) => {
  const [value, setValue] = useState(placeholder);

  function defaultMap(data) {
    if (!data || !data?.title) return null;
    const res = `${data.title || ''}`.trim();
    return res || null;
  }

  useEffect(() => {
    let mounted = true;
    if (!id) {
      setValue('');
      return;
    }

    const fetchData = async () => {
      try {
        const { data } = await api.get(
          `/${resource}${id ? `/${id}` : ''}${filter ? `?${filter}` : ''}`,
        );
        const mapped =
          typeof mapResponse === 'function'
            ? mapResponse(data)
            : defaultMap(data);
        const final = mapped ?? data?.title;
        if (mounted) setValue(final);
      } catch (err) {
        if (mounted) setValue('Fehler beim Laden');
      }
    };

    fetchData();
    return () => {
      mounted = false;
    };
  }, [id, resource, mapResponse]);

  return <span>{value}</span>;
};
